// @flow
import React from "react"
import { isEmpty, path } from "ramda"
import featureFlags from "global/feature-flags"
import { formatPricing } from "data/units/money/formatters"
import Reserve from "./Reserve"
import { Text } from "componentsStyled/Typography/Texts"
import { SubTitle } from "componentsStyled/Typography/Titles"
import Description from "components/Description"
import PlanBanner from "components/PlanBanner"
import type {
  ProductVariant,
  ProductVariantAvailableAffiliate,
} from "data/product/types"
import type { User } from "data/user/types"
import { formatVariantParam } from "data/product/formatters"
import { getPlan } from "data/plans/helpers"
import {
  Space
} from "componentsStyled/Layout/Spacers"
import { SectionHeading } from "./styled"

type Props = {|
  productVariant: ProductVariant,
  variantAffiliate: ProductVariantAvailableAffiliate,
  user: User,
|}

const Detail = ({ productVariant, variantAffiliate, user }: Props) => {
  const pricing = variantAffiliate && variantAffiliate.pricing
  const binding = formatVariantParam("binding")(productVariant.parameters)

  const plan = featureFlags.showPassportUpsellInReservationFlow() && getPlan("Passport")
  const isSubscribedToPassport = plan && plan.slug === path(["subscription", "plan", "type", "slug"], user)

  return (
    <React.Fragment>
      {!isEmpty(binding) && <SubTitle>{binding}</SubTitle>}
      {pricing && (
        <Text>
          <Text inline black book>
            {formatPricing(
              pricing,
              variantAffiliate.location.country.currency,
            )}
          </Text>{" "}
          per day
        </Text>
      )}
      {isSubscribedToPassport
        ? <Text black bold>Free for passport members like you!</Text>
        : plan && <PlanBanner plan={plan} />
      }
      <Space />
      <Reserve
        productVariant={productVariant}
        variantAffiliate={variantAffiliate}
      />
      <Space />
      <SectionHeading>description</SectionHeading>
      <Description description={productVariant.product.description} />
      <Space />
    </React.Fragment>
  )
}

export default Detail



// WEBPACK FOOTER //
// ./src/pages/Product/Detail/index.js